/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { Field } from 'vant';
import type { FullAmountCouponType } from '@/views_v2/apply-product/types';
import type {
  ApplyChannelData,
} from '@/api/apply-product/types';
import LoadingSkeleton from '../loading-skeleton';

const style = require('./index.module.scss');

@Component
export default class MoneyInputCom extends Vue {
  @Prop(Object) readonly channel!: ApplyChannelData;

  @Prop(String) readonly amount!: string;

  @Prop(String) readonly maxAmount!: string;

  @Prop(Boolean) readonly editable!: boolean;

  @Prop(String) readonly placeholder!: string;

  @Prop(Boolean) readonly showFullAmountCouponTag!: boolean;

  @Prop(Object) readonly fullAmountCoupon!: FullAmountCouponType;

  // 是否获取焦点
  private isInputFocused = false;

  // 是否显示clear按钮
  private get showClearIcon(): boolean {
    return Boolean(this.isInputFocused && this.amount);
  }

  /** 是否显示满额提现券营销标签 */
  private get needShowFullAmountCouponTag(): boolean {
    const result = !this.isInputFocused && this.showFullAmountCouponTag;
    if (result) {
      this.$ubtModuleExposeNew('finance_loan_apply_moneyFullGuid', {
        commodityId: this.channel.productId,
      });
    }
    return result;
  }

  // 是否显示全部按钮
  private get showAllAmount(): boolean {
    return (
      Number(this.amount) < Number(this.maxAmount)
    );
  }

  private render() {
    return (
      <div class={style.newMoneyInput}>
        <div class={style.inputContent}>
          <Field
            ref="input"
            type="tel"
            maxlength={7}
            class={style.inputField}
            v-model={this.amount}
            border={false}
            center
            readonly={!this.editable}
            onInput={this.onInputEvent.bind(this)}
            onFocus={this.onFocusEvent.bind(this)}
            onBlur={this.onBlurEvent.bind(this)}
            onChange={this.onChangeEvent.bind(this)}
          />
          {/* placeholder */}
          {!this.amount && (this.placeholder
            ? <span class={style.placeholder}>{this.placeholder}</span>
            : <LoadingSkeleton class={style.placeholder} width={131} height={40} radius={8} />
          )}
          {/* 右侧操作按钮区域 */}
          <div class={style.handleContainer}>
            {/* 清除按钮 */}
            {this.showClearIcon
              && <span class={style.clearIcon} onClick={this.onClearClick.bind(this)} />}
            {/* 满额提现券营销标签 */}
            {this.needShowFullAmountCouponTag
              && <span
                  class={style.fullAmountCouponTag}
                  onClick={this.selectFullAmountCoupon.bind(this)}
                  >全额借款 最高返{this.fullAmountCoupon?.amount}</span>}
            {/* 全部按钮 */}
            {this.showAllAmount
              && <span
                  class={style.all}
                  onClick={this.onAllAmountClick.bind(this)}
                  onMousedown={(e: MouseEvent) => e.preventDefault()}
                  onTouchend={(e: TouchEvent) => {
                    e.preventDefault();
                    this.onAllAmountClick();
                  }}
                >全部</span>}
          </div>
        </div>
        {/* 提示区 */}
        {this.$slots.tips}
      </div>
    );
  }

  private onFocusEvent() {
    this.isInputFocused = true;
  }

  private onBlurEvent() {
    this.isInputFocused = false;
    this.$emit('blur');
  }

  private onChangeEvent() {
    this.$emit('change');
  }

  private onInputEvent(value: number) {
    this.$emit('input', value);
  }

  private onClearClick() {
    this.$emit('clear');

    if (this.$refs.input) {
      (this.$refs.input as HTMLInputElement).focus();
    }
  }

  /** 点击满额提现券标签 */
  private selectFullAmountCoupon() {
    this.$ubtPageButtonNew('finance_loan_apply_moneyFullGuid', {
      commodityId: this.channel.productId,
    });
    this.$emit('selectFullAmountCoupon');
  }

  private onAllAmountClick() {
    this.$ubtPageButtonNew('finance_FinanceLoanApply_All', {
      moneyFullGuid: this.needShowFullAmountCouponTag,
      commodityId: this.channel.productId,
    });
    this.$emit('clickAll');
    // 如果显示了满额提现券标签，则选中满额提现券
    if (this.needShowFullAmountCouponTag) {
      this.$emit('selectFullAmountCoupon');
    }
  }
}
